import { height, lineHeight } from "@mui/system";
import moment from "moment";
import { useEffect } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import { Table } from "./MoveOut.styled";
import General from '../../stores/GeneralStore'
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import MoveInOut, { MoveOutData } from "../../stores/MoveInOutStore";
interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  dues: Obj;
  sewerageNumber: string;
  loadMoveOutDues: () => Promise<void>,
  duesLoader: Boolean,
}

const Reviews = ({ dues, loadMoveOutDues, Next, Previous, sewerageNumber, duesLoader }: Props) => {

  useEffect(() => {
    loadMoveOutDues()
  }, [])

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <>
      {duesLoader ? <div style={{minHeight: "55vh",marginBottom: General?.isLargeScreen ? '' : "2rem"}}><Spinner /></div> : <TabContainer style={{ transition: "all 1s ease-in-out",display: "flex", flexDirection: "column", minHeight: "53vh", marginBottom: General?.isLargeScreen ? '' : "2rem" }}>
        <div
          style={{
            display: "flex",
            width: General?.isLargeScreen ? "55%" : "98%",
            justifyContent: "space-between",
            height: "0vh",
            alignItems: "center",
            marginBottom: "10px",
            lineHeight: "5px",
            marginTop: "3rem",
          }}>
          <div>
            <p  style={{
              fontWeight: "700", fontSize: `${General.accessibility.fontSize}rem`, fontFamily: "Segoe UI", fontStyle: "normal", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss
            }}>{General?.codeLabels["cm_moproperty"]?.label !== undefined ? General?.codeLabels["cm_moproperty"]?.label : "Selected property for move out"}</p>
            <p  style={{ fontFamily: "Segoe UI", fontStyle: "normal", fontWeight: "400", fontSize: `${1.25 * General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>{sewerageNumber}</p>
          </div>
          <div>
            <p  style={{ fontWeight: "700", fontSize: `${General.accessibility.fontSize}rem`, fontFamily: "Segoe UI", fontStyle: "normal", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>{General?.codeLabels["cm_moveout_date"]?.label ? General?.codeLabels["cm_moveout_date"]?.label : "Move Out Date"}</p>
            <p  style={{
              fontFamily: "Segoe UI", fontStyle: "normal", fontWeight: "400", fontSize: `${1.25 * General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: 'ltr'
            }}>{MoveInOut.moveOutInfo?.serviceTerminationDate}</p>
          </div>
        </div>
        <table className="table " style={{
          borderSpacing: "0",
        }}>
          <thead style={{
            margin: "0",
            color: contrast?.contrastColor ? contrast?.contrastColor : "",
            background: contrast?.contrastBackground ? contrast?.contrastBackground : ''
          }}>

            <tr style={{ color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss, background: contrast?.contrastColor ? contrast?.contrastColor : '#edf4f6', }}>
              <th style={{ color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss, background: contrast?.contrastColor ? contrast?.contrastColor : '#edf4f6', fontSize: `${0.875 * General.accessibility.fontSize}rem`, fontWeight: "700", display: 'flex', justifyContent: 'space-between' }}>
                {General?.codeLabels["cm_description"]?.label !== undefined ? General?.codeLabels["cm_description"]?.label : "Description"}
              </th>
              <th style={{ color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss, background: contrast?.contrastColor ? contrast?.contrastColor : '#edf4f6', textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? 'left' : "right", fontSize: `${0.875 * General.accessibility.fontSize}rem`, whiteSpace: "nowrap" }}>
                {General?.codeLabels["cm_amountaed"]?.label !== undefined ? General?.codeLabels["cm_amountaed"]?.label : "Amount (AED)"}
              </th>
            </tr>
          </thead>
          <tbody style={{}}>

            <tr >
              <td style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                {General?.codeLabels["cm_motenantfee"]?.label !== undefined ? General?.codeLabels["cm_motenantfee"]?.label : "Tenant Service Fee Due"}
              </td>
              <td style={{ textAlign: 'right', display: 'flex', justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : "flex-end", alignItems: 'center', fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: 'ltr' }}>{new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(dues.tenantServiceFeeDue)}</td>
            </tr>
            <tr>
              <td style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                {General?.codeLabels["cm_moownerfee"]?.label !== undefined ? General?.codeLabels["cm_moownerfee"]?.label : "Owner Service Fee Due"}
              </td>
              <td style={{ textAlign: 'right', display: 'flex', justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : "flex-end", alignItems: 'center', fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: 'ltr' }}>{new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(dues.ownerServiceFeeDue)}</td>
            </tr>
            {/* <tr>
                  <td style={{fontSize:`${General.accessibility.fontSize}rem`,color: contrast?.contrastColor ? contrast?.contrastColor: "" }}>
                  {General?.codeLabels["cm_nocdeliveryfee"]?.label !== undefined ? General?.codeLabels["cm_nocdeliveryfee"]?.label : "Delivery Charge"}
                  </td>
                  <td style={{ textAlign:'right',display:'flex',justifyContent:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?"":"flex-end",alignItems:'center',fontSize:`${General.accessibility.fontSize}rem`,color: contrast?.contrastColor ? contrast?.contrastColor: "" }} >{dues.deliveryCharge}</td>
                </tr> */}
            <tr>
              <td style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                {General?.codeLabels["cm_motenantfee2"]?.label !== undefined ? General?.codeLabels["cm_motenantfee2"]?.label : "Tenant Service Fee Due for properties"}
              </td>
              <td style={{ textAlign: 'right', display: 'flex', justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : "flex-end", alignItems: 'center', fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: 'ltr' }}>{new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(dues.otherPropertyDue)}</td>
            </tr>
            <tr>
              <td style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                {General?.codeLabels["cm_modepost"]?.label !== undefined ? General?.codeLabels["cm_modepost"]?.label : "Deposit paid"}
              </td>
              <td style={{ textAlign: 'right', display: 'flex', justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : "flex-end", alignItems: 'center', fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: 'ltr' }}>{new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format((dues.depositPaid))}</td>
            </tr>
            <tr >

              <td style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                {General?.codeLabels["cm_monoccharge"]?.label !== undefined ? General?.codeLabels["cm_monoccharge"]?.label : "NOC Charge"}
              </td>
              <td style={{ textAlign: 'right', display: 'flex', justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : "flex-end", alignItems: 'center', fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: 'ltr' }}>{new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(dues.nocFees)}</td>
            </tr>
            <tr>
              <td style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                {General?.codeLabels["cm_monewcharge"]?.label !== undefined ? General?.codeLabels["cm_monewcharge"]?.label : "New Charge as of Move Out Date"}
              </td>
              <td style={{ textAlign: 'right', display: 'flex', justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : "flex-end", alignItems: 'center', fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: 'ltr' }}>{new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(dues.newCharge)}</td>
            </tr>

            <tr>
              <td style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                {General?.codeLabels["cm_movat"]?.label !== undefined ? General?.codeLabels["cm_movat"]?.label : "VAT Charges"}
              </td>
              <td style={{ textAlign: 'right', display: 'flex', justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : "flex-end", alignItems: 'center', fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: "ltr" }}>{new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(dues.valueAddedTax)}</td>
            </tr>


            <tr style={{
              background: " rgba(229, 239, 242, 0.7)", color: "#101E8E", fontWeight: "700", fontSize: "16px"
            }}>
              <td style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                {General?.codeLabels["cm_mob_totamttopaid"]?.label !== undefined ? General?.codeLabels["cm_mob_totamttopaid"]?.label : "Total amount to be paid"}
              </td>
              <td style={{ textAlign: 'right', display: 'flex', justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : "flex-end", alignItems: 'center', fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, direction: 'ltr' }}>{new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(dues.totalAmountTobePaid)}</td>
            </tr>

          </tbody>
        </table>
        <div style={{
          display: "flex",
          flexDirection: General?.isLargeScreen ? 'row' : "column",
          height: "4vh",
          alignItems: "center",
          gap: "2rem"
        }}>
          <ButtonSecondary
            style={{
              width: General?.isLargeScreen ? "163px" : "98%", height: "50px", fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700", fontSize: `${General.accessibility.fontSize}rem`, 
              background: contrast?.contrastColor ? contrast?.contrastBackground : "#e7e9f8",
              color: contrast?.contrastBackground ? contrast?.contrastColor : ColorAss,
              border: contrast?.contrastBackground ? contrast?.contrastColor : "none"
            }}
            onClick={Previous}
          >
            {General?.codeLabels["cm_backbutton"]?.label !== undefined ? General?.codeLabels["cm_backbutton"]?.label : "Back"}
          </ButtonSecondary>
          <ButtonSecondary
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: `${General.accessibility.fontSize}rem`,
              width: General?.isLargeScreen ? "163px" : "98%", height: "50px",
              color: contrast?.contrastColor ? contrast?.contrastBackground :"#fff",
              backgroundColor: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              border: "none"
            }}
            onClick={Next}
          >
            {General?.codeLabels["cm_next"]?.label !== undefined ? General?.codeLabels["cm_next"]?.label : "Next"}
          </ButtonSecondary>
        </div>
      </TabContainer>}
    </>
  );
};

export default Reviews;
